import React from 'react';

type PaginationControlsProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

function PaginationControls({ page, totalPages, onChange }: PaginationControlsProps) {
  return (
    <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
      <div>Strana {page} z {totalPages}</div>
      <div className="flex gap-2">
        <button
          type="button"
          className="btn-secondary"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          Predchádzajúca
        </button>
        <button
          type="button"
          className="btn-secondary"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
        >
          Ďalšia
        </button>
      </div>
    </div>
  );
}

export default PaginationControls;
